import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheck, FaMicrochip } from "react-icons/fa";

import CustomNavbar from "../components/CustomNavbar";
import Footer from "../components/Footer";
import { technologies } from "../data/technologies";

const HIGHLIGHTS = [
  "Salesforce CRM Solutions",
  "MuleSoft Enterprise Integrations",
  "Boomi Cloud Connectivity",
  "Oracle Fusion Transformation",
  "API Management & Security",
  "Cloud & Enterprise Automation",
];

function Technology() {
  return (
    <>
      <CustomNavbar />

      <style>{`
        .tcp {
          --peach-deep: #ff6b35;
          --peach: #ff9066;
          --peach-soft: #f3c09f;
          --peach-tint: #ffe9e0;
          --peach-ink: #c2410c;
        }

        /* --- Hero --- */
        .tcp-hero {
          position: relative; overflow: hidden;
          padding: clamp(52px, 7vw, 88px) 0;
          background:
            radial-gradient(42rem 24rem at 86% 6%, rgba(255,107,53,.30), transparent 62%),
            linear-gradient(135deg, #ff9066 0%, #f3c09f 48%, #fff8f5 100%);
          color: #0f172a;
        }
        .tcp-hero__blob {
          position: absolute; border-radius: 50%; pointer-events: none;
          filter: blur(80px); opacity: .5;
          width: 24rem; height: 24rem; bottom: -9rem; left: -8rem;
          background: radial-gradient(circle, #fff3ec, transparent 70%);
        }
        .tcp-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: #ffffffdd; color: var(--peach-ink);
          padding: 9px 22px; border-radius: 999px;
          font-weight: 700; font-size: .78rem; letter-spacing: .1em;
          box-shadow: 0 8px 20px rgba(194,65,12,.16);
        }
        .tcp-hero__title {
          margin-top: 22px; font-weight: 800; letter-spacing: -.02em;
          font-size: clamp(1.9rem, 4.6vw, 3.1rem); line-height: 1.14;
        }
        .tcp-hero__title em {
          font-style: normal;
          background: linear-gradient(96deg, #c2410c, #ff6b35 60%, #b91c1c);
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .tcp-hero__lead {
          margin-top: 18px; color: #4a3a33;
          font-size: clamp(1rem, 1.7vw, 1.08rem); line-height: 1.85; max-width: 560px;
        }
        .tcp-btn {
          display: inline-flex; align-items: center; gap: 10px;
          text-decoration: none; font-weight: 700;
          padding: 13px 26px; border-radius: 14px;
          transition: transform .22s ease, box-shadow .22s ease, background .22s ease;
        }
        .tcp-btn--solid {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #0f172a; box-shadow: 0 12px 28px rgba(255,107,53,.4);
        }
        .tcp-btn--solid:hover, .tcp-btn--solid:focus-visible {
          color: #fff; transform: translateY(-3px);
          box-shadow: 0 18px 38px rgba(255,107,53,.55);
        }
        .tcp-btn--ghost {
          background: rgba(255,255,255,.72); color: #0f172a;
          border: 1.5px solid rgba(15,23,42,.16);
        }
        .tcp-btn--ghost:hover, .tcp-btn--ghost:focus-visible {
          background: #fff; color: #0f172a; transform: translateY(-3px);
        }
        .tcp-btn svg { transition: transform .22s ease; }
        .tcp-btn:hover svg { transform: translateX(4px); }

        .tcp-panel {
          background: #fff; border-radius: 24px;
          padding: clamp(26px, 3.4vw, 38px);
          box-shadow: 0 26px 55px rgba(194,65,12,.22);
          border: 1px solid #ffe3d6;
        }
        .tcp-panel__h { font-weight: 800; color: #0f172a; font-size: 1.3rem; margin-bottom: 20px; }
        .tcp-panel__row {
          display: flex; align-items: flex-start; gap: 11px;
          color: #334155; font-size: .95rem; margin-bottom: 12px;
        }
        .tcp-tick {
          flex-shrink: 0; margin-top: 2px;
          width: 21px; height: 21px; border-radius: 50%;
          display: grid; place-items: center; font-size: .58rem; color: #fff;
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
        }
        .tcp-panel__note {
          margin: 18px 0 0; padding-top: 16px; border-top: 1px solid #f1e4dc;
          color: #64748b; font-size: .9rem; line-height: 1.8;
        }

        /* --- Platform grid: dark, echoing the home Technology band ---
           Extra bottom padding leaves room for the footer's CTA panel,
           which overlaps upward into whatever section precedes it. */
        .tcp-grid {
          position: relative; overflow: hidden;
          padding: clamp(56px, 7vw, 92px) 0 clamp(92px, 10vw, 136px);
          /* Offsets the sticky navbar when the hero's anchor link jumps here */
          scroll-margin-top: 80px;
          color: #fff;
          background:
            radial-gradient(56rem 30rem at 84% 6%, rgba(255,107,53,.26), transparent 60%),
            radial-gradient(48rem 30rem at 8% 94%, rgba(255,144,102,.16), transparent 60%),
            linear-gradient(160deg, #131f36 0%, #0f172a 46%, #0b1120 100%);
        }
        .tcp-grid__mesh {
          position: absolute; inset: 0; pointer-events: none;
          background-image:
            linear-gradient(rgba(255,144,102,.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,144,102,.07) 1px, transparent 1px);
          background-size: 72px 72px;
          mask-image: radial-gradient(78% 58% at 50% 42%, #000 22%, transparent 100%);
          -webkit-mask-image: radial-gradient(78% 58% at 50% 42%, #000 22%, transparent 100%);
        }
        .tcp-grid__badge {
          display: inline-flex; align-items: center; gap: 9px;
          padding: 9px 22px; border-radius: 999px;
          background: rgba(255,144,102,.14);
          border: 1px solid rgba(255,144,102,.34);
          color: var(--peach-soft);
          font-weight: 700; font-size: .8rem; letter-spacing: .08em;
        }
        .tcp-h2 {
          margin-top: 20px; color: #fff; font-weight: 800;
          font-size: clamp(1.7rem, 3.6vw, 2.7rem);
          line-height: 1.16; letter-spacing: -.02em;
        }
        .tcp-h2 em {
          font-style: normal;
          background: linear-gradient(105deg, var(--peach-soft), var(--peach) 55%, var(--peach-deep));
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .tcp-lead {
          max-width: 740px; margin: 14px auto 0;
          color: #cbd5e1; line-height: 1.85; font-size: clamp(.96rem, 1.6vw, 1.05rem);
        }

        .tcp-tile {
          display: flex; flex-direction: column; height: 100%;
          padding: 26px 24px; border-radius: 20px; text-decoration: none;
          background: rgba(255,255,255,.045);
          border: 1px solid rgba(255,255,255,.09);
          backdrop-filter: blur(8px);
          transition: transform .26s ease, background .26s ease,
                      border-color .26s ease, box-shadow .26s ease;
        }
        .tcp-tile:focus-visible { outline: 3px solid var(--peach); outline-offset: 3px; }
        .tcp-tile__head { display: flex; align-items: center; gap: 14px; margin-bottom: 14px; }
        .tcp-tile__icon {
          width: 54px; height: 54px; border-radius: 15px; flex-shrink: 0;
          display: grid; place-items: center;
          background: rgba(255,144,102,.14);
          border: 1px solid rgba(255,144,102,.3);
          color: var(--peach);
          transition: background .26s ease, color .26s ease, transform .26s ease;
        }
        .tcp-tile__name { margin: 0; font-weight: 700; font-size: 1.16rem; color: #fff; }
        .tcp-tile__text { color: #b9c4d4; font-size: .93rem; line-height: 1.75; margin-bottom: 16px; }
        .tcp-tile__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 18px; }
        .tcp-tile__chip {
          display: inline-flex; align-items: center; gap: 6px;
          background: rgba(255,144,102,.12); color: var(--peach-soft);
          border-radius: 999px; padding: 4px 11px; font-size: .72rem; font-weight: 600;
        }
        .tcp-tile__chip svg { font-size: .55rem; flex-shrink: 0; }
        .tcp-tile__more {
          margin-top: auto; padding-top: 14px;
          border-top: 1px solid rgba(255,255,255,.09);
          display: inline-flex; align-items: center; gap: 8px;
          color: var(--peach); font-weight: 700; font-size: .9rem;
        }
        .tcp-tile__more svg { transition: transform .26s ease; }

        /* A mouse hovers; a finger can't. On touch, lib/touchMotion.js adds
           .is-live as the tile scrolls through the middle of the screen. */
        .tcp-tile:hover,
        .tcp-tile.is-live {
          transform: translateY(-7px);
          background: rgba(255,144,102,.09);
          border-color: rgba(255,144,102,.55);
          box-shadow: 0 20px 44px rgba(0,0,0,.45);
        }
        .tcp-tile:hover .tcp-tile__icon,
        .tcp-tile.is-live .tcp-tile__icon {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #fff; transform: scale(1.06);
        }
        .tcp-tile:hover .tcp-tile__more svg,
        .tcp-tile.is-live .tcp-tile__more svg { transform: translateX(5px); }

        @media (max-width: 575.98px) { .tcp-btn { width: 100%; justify-content: center; } }
        @media (prefers-reduced-motion: reduce) {
          .tcp-tile, .tcp-tile__icon, .tcp-btn, .tcp-tile__more svg { transition: none; }
          .tcp-tile:hover, .tcp-btn:hover { transform: none; }
          .tcp-grid { scroll-behavior: auto; }
        }
      `}</style>

      <div className="tcp">
        {/* Hero */}
        <section className="tcp-hero">
          <span className="tcp-hero__blob" />
          <Container style={{ position: "relative", zIndex: 1 }}>
            <Row className="align-items-center g-5">
              <Col lg={6} data-aos="fade-right">
                <span className="tcp-badge">
                  <FaMicrochip />
                  TECHNOLOGY EXPERTISE
                </span>

                {/* theme.css hides <br> in section headings below 576px —
                    the explicit space stops the halves concatenating. */}
                <h1 className="tcp-hero__title">
                  Powering Digital
                  <br />{" "}
                  <em>Transformation</em>
                </h1>

                <p className="tcp-hero__lead">
                  Leveraging leading enterprise platforms, integration
                  technologies, cloud solutions, and automation frameworks to
                  help organizations innovate, modernize, and accelerate growth.
                </p>

                {/* "Explore Technologies" was an inert <Button> before */}
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <a href="#platforms" className="tcp-btn tcp-btn--solid">
                    Explore Technologies
                    <FaArrowRight />
                  </a>
                  <Link to="/contact" className="tcp-btn tcp-btn--ghost">
                    Talk to an Expert
                  </Link>
                </div>
              </Col>

              <Col lg={6} data-aos="fade-left">
                <div className="tcp-panel">
                  <h2 className="tcp-panel__h">Technology Highlights</h2>

                  {HIGHLIGHTS.map((h) => (
                    <div className="tcp-panel__row" key={h}>
                      <span className="tcp-tick">
                        <FaCheck />
                      </span>
                      {h}
                    </div>
                  ))}

                  <p className="tcp-panel__note">
                    Delivering enterprise-grade technology solutions that improve
                    efficiency, scalability, and business performance.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Platforms */}
        <section className="tcp-grid" id="platforms">
          <span className="tcp-grid__mesh" />
          <Container style={{ position: "relative", zIndex: 1 }}>
            <div className="text-center mb-5" data-aos="fade-up">
              <span className="tcp-grid__badge">
                <FaMicrochip />
                TECHNOLOGY STACK
              </span>
              <h2 className="tcp-h2">
                Platforms <em>We Work With</em>
              </h2>
              <p className="tcp-lead">
                Enterprise-grade technologies powering digital transformation,
                integration, automation, and innovation.
              </p>
            </div>

            <Row className="g-4">
              {technologies.map((tech, i) => {
                const { Icon } = tech;
                return (
                  <Col
                    xl={4}
                    md={6}
                    key={tech.slug}
                    data-aos="zoom-in"
                    data-aos-delay={(i % 3) * 90}
                  >
                    <Link to={`/technology/${tech.slug}`} className="tcp-tile" data-live>
                      <span className="tcp-tile__head">
                        <span className="tcp-tile__icon">
                          <Icon size={24} />
                        </span>
                        <h3 className="tcp-tile__name">{tech.title}</h3>
                      </span>

                      <p className="tcp-tile__text">{tech.description}</p>

                      {/* Detail-page content the listing never surfaced */}
                      <span className="tcp-tile__chips">
                        {(tech.features || []).slice(0, 3).map((f) => (
                          <span className="tcp-tile__chip" key={f}>
                            <FaCheck />
                            {f}
                          </span>
                        ))}
                      </span>

                      <span className="tcp-tile__more">
                        Explore <FaArrowRight />
                      </span>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Technology;
